import { createNav, bindNav } from "./components/Nav.js";
import { createFooter } from "./sections/Footer.js";
import {
  createInsightDetailHero,
  createInsightDetailBody,
} from "./sections/insights/InsightDetail.js";
import {
  getInsightDetail,
  insightDetailRoute,
  insightListFallbackHref,
} from "../config/insightDetails.js";

export function mountInsightDetailPage(root, slug) {
  const detail = getInsightDetail(slug);

  if (!detail) {
    window.location.replace(insightListFallbackHref());
    return {
      canvas: null,
      updateNavActive: () => {},
      documentTitle: "Taldel — Insight not found",
      sections: {},
    };
  }

  if (detail.slug && slug && detail.slug !== String(slug).toLowerCase()) {
    window.location.replace(insightDetailRoute(detail.slug));
    return {
      canvas: null,
      updateNavActive: () => {},
      documentTitle: `Taldel — ${detail.title}`,
      sections: {},
    };
  }

  const canvasLayer = document.createElement("div");
  canvasLayer.className = "canvas-layer";
  canvasLayer.innerHTML = `<canvas id="canvas" aria-hidden="true"></canvas>`;

  const contentLayer = document.createElement("div");
  contentLayer.className = "content-layer content-layer--insight-detail";

  const nav = createNav();

  contentLayer.append(
    nav,
    createInsightDetailHero(detail),
    createInsightDetailBody(detail),
    createFooter()
  );

  root.append(canvasLayer, contentLayer);

  const updateNavActive = bindNav(nav, {
    page: "insight-detail",
    serviceSlug: detail.serviceId,
    sectionMap: {
      article: insightDetailRoute(detail.slug, "article"),
      body: insightDetailRoute(detail.slug, "body"),
      next: insightDetailRoute(detail.slug, "next"),
    },
  });

  return {
    canvas: canvasLayer.querySelector("#canvas"),
    updateNavActive,
    documentTitle: `Taldel — ${detail.title}`,
    sections: {
      article: contentLayer.querySelector("#article"),
      body: contentLayer.querySelector("#body"),
      next: contentLayer.querySelector("#next"),
    },
    detail,
  };
}
